import { useSelector } from 'react-redux';
import GlobalSelectors from '../../store/global-selectors';
import { selectAccountInformationAccountInformation } from '../../store/account-information/account-information.selectors';
import { TRUSTED } from '../../constants/account-information';

export const useIsAccountLimited = () => {
  // TODO: this needs to figure out if the purchase is directly related to AP-backed wallets or not, might need a specific wallet passed in to handle legacy wallets and BYOA Stamps
  // BYOA add funds might be avoided because it has its own older modal.
  const accountInfo = useSelector(selectAccountInformationAccountInformation);
  const homeCountry = useSelector(GlobalSelectors.selectSellerHomeCountry);

  if (!accountInfo || homeCountry !== 'US') {
    return false;
  }

  const { trustLevel, isWalletCreatedAfterAPLaunch } = accountInfo;
  if (!isWalletCreatedAfterAPLaunch) {
    return false;
  }

  return trustLevel && trustLevel !== TRUSTED;
};
